module.exports = __webpack_public_path__ + "img/PVP_EgyptTechPtolemysMight1_ua.e2f706e1.webp";